<template>
  <div>
    <div id="fullpage">
      <!-- 第一页 -->
      <div class="section section1">
        <div class="page1">
          <div class="content">
            <div class="text_box animated-content">
              <h1 class="head_name">加入九吨</h1>
              <!-- <p class="en_title">Nintone Business</p> -->
              <div class="icon_origin"></div>
              <div class="page">
                <div class="img_btn">
                  <img
                    v-show="page_join !== 1"
                    src="@/assets/img/back_btn.png"
                    @click="backPage"
                    style="cursor: pointer"
                  />
                </div>
                <!-- <div class="btns">
                  <span class="page_btn">{{ page_join }}</span> /
                  <span>{{ totle }}</span>
                </div> -->
                <div class="img_btn">
                  <img
                    v-show="page_join != totle && totle != 1"
                    src="@/assets/img/go_btn.png"
                    @click="goPage"
                    style="cursor: pointer"
                  />
                </div>
              </div>
            </div>
            <div class="img_box">
              <div v-for="(item, index) in jobsList" :key="index">
                <img :src="item.resource" />
                <p class="title">{{ item.title }}</p>
                <div class="btn" @click="goWebPage(item.extends)">查看职位</div>
              </div>
              <!--  <div>
                <img src="@/assets/img/rule.png" />
                <p class="title">高级用户运营</p>
                <div class="btn">查看职位</div>
              </div>
              <div>
                <img src="@/assets/img/rule.png" />
                <p class="title">高级用户运营</p>
                <div class="btn">查看职位</div>
              </div>
              <div>
                <img src="@/assets/img/rule.png" />
                <p class="title">高级用户运营</p>
                <div class="btn">查看职位</div>
              </div> -->
            </div>
          </div>
        </div>
      </div>
      <!-- 第二页 -->
      <div class="section section2">
        <div class="page2">
          <div class="content">
            <div class="text_box animated-content">
              <h1 class="head_name">九吨福利</h1>
              <!-- <p class="en_title">Nintone Business</p> -->
              <div class="icon_origin"></div>
            </div>
            <div class="welfare_list">
              <div class="grid-item"></div>
              <div
                :class="
                  index == 0 || index == 2 || index == 3 || index == 5
                    ? 'grid-item bgd8d animated-content-top'
                    : 'grid-item animated-content'
                "
                v-for="(item, index) in welfareList"
                :key="index"
              >
                <h1 class="num">
                  <img :class="item.imgclass" :src="item.img" />
                </h1>
                <p class="title">{{ item.title }}</p>
                <p class="cont">{{ item.subTitle }}</p>
              </div>
              <!--  <div class="grid-item bgd8d">
                <h1 class="num item01">
                  <img class="img01" src="@/assets/img/01.png" />
                </h1>
                <p class="title">薪酬待遇</p>
                <p class="cont">周末双休，弹性上下班时间，带薪年假</p>
              </div>
              <div class="grid-item">
                <h1 class="num item01">
                  <img class="img02" src="@/assets/img/02.png" />
                </h1>
                <p class="title">工作时间</p>
                <p class="cont">同行业有竞争力的薪酬，五险一金，丰厚的年终奖</p>
              </div>
              <div class="grid-item bgd8d">
                <h1 class="num item01">
                  <img class="img02" src="@/assets/img/03.png" />
                </h1>
                <p class="title">餐饮零食</p>
                <p class="cont">午餐补贴，每日不同零食供应，每月豪华下午</p>
              </div>
              <div class="grid-item bgd8d">
                <h1 class="num item01">
                  <img class="img02" src="@/assets/img/04.png" />
                </h1>
                <p class="title">节日生日</p>
                <p class="cont">
                  不同节假日定制礼盒、礼品，定制生日礼物，三周年员工纪念
                </p>
              </div>
              <div class="grid-item">
                <h1 class="num item01">
                  <img class="img02" src="@/assets/img/05.png" />
                </h1>
                <p class="title">健康守护</p>
                <p class="cont">每年豪华体检套餐，每周五下午健身房锻炼时间</p>
              </div>
              <div class="grid-item bgd8d">
                <h1 class="num item02">
                  <img class="img02" src="@/assets/img/06.png" />
                </h1>
                <p class="title">旅游团建</p>
                <p class="cont">
                  国内外定制游，每月部门团建，不定期举办游戏大赛、运动会等
                </p>
              </div>
              <div class="grid-item">
                <h1 class="num item02">
                  <img class="img02" src="@/assets/img/07.png" />
                </h1>
                <p class="title">晋升成长</p>
                <p class="cont">定期公费培训，优秀员工学习基金</p>
              </div> -->
            </div>
          </div>
        </div>
      </div>

      <!-- 第三页 -->
      <div class="section section3">
        <div class="page3">
          <div class="content">
            <div class="text_box animated-content-top">
              <h1 class="head_name">联系我们</h1>
              <!-- <p class="en_title">Nintone Business</p> -->
              <div class="icon_origin"></div>
            </div>
            <div class="img_box animated-content-top">
              <p>地址：{{ info.address }}</p>
              <p class="center">电话：{{ info.tel }}</p>
              <p>邮箱：{{ info.mail }}</p>
            </div>
          </div>
          <div id="map" class="animated-content"></div>
        </div>
      </div>
    </div>

    <div class="xiahua" v-if="nowIndex != 2">
      <p v-if="someData == '1' && page_name == 'index'">
        <img @click="changeIndex" src="@/assets/img/xiahua.svg" />
      </p>
      <p v-else>
        <img @click="changeIndex" src="@/assets/img/xiahua_00.svg" />
      </p>
    </div>
  </div>
</template>

<script>
import fullpage from "fullpage.js";
// import { swiper.css, SwiperSlide } from 'vue-awesome-swiper'
import { mapGetters, mapActions } from "vuex";
import "swiper/css/swiper.css";
import Swiper from "swiper";
export default {
  data() {
    return {
      fillpage: null,
      page: 1,
      totle: 1,
      page_join: 1,
      totle_join: 5,
      map: null,
      center: [106.50083, 29.60816], // 设置地图中心点坐标，可根据需求修改
      zoom: 13,
      jobsList: [],
      welfareList: [],
      imgList: [
        { img: require("@/assets/img/01.png"), imgclass: "img01" },
        { img: require("@/assets/img/02.png"), imgclass: "img02" },
        { img: require("@/assets/img/03.png"), imgclass: "img03" },
        { img: require("@/assets/img/04.png"), imgclass: "img04" },
        { img: require("@/assets/img/05.png"), imgclass: "img05" },
        { img: require("@/assets/img/06.png"), imgclass: "img06" },
        { img: require("@/assets/img/07.png"), imgclass: "img07" },
      ],
      info: {
        tel: "",
        title: "",
        mail: "",
        copyright: "",
      },
      nowIndex: null,
    };
  },
  watch: {
    $route: {
      handler: function (val) {
        this.fillpage
          ? this.fillpage.moveTo(
              this.$route.query.page ? this.$route.query.page : 1
            )
          : "";
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {
    ...mapGetters(["someData"]),
    ...mapGetters(["page_name"]),
  },
  mounted() {
    // 公司招聘接口
    this.getJobs();
    // 公司福利接口
    this.getWelfare();
    // 公司基础信息
    this.getInfo();
    this.initSwiper();
    this.initFullPage();
    this.initMap();
    this.fillpage.moveTo(this.$route.query.page ? this.$route.query.page : 1);
  },

  // 销毁fullpage
  beforeDestroy() {
    if (this.fillpage) {
      this.fillpage.destroy("all");
    }
  },
  methods: {
    initFullPage() {
      let _this = this;
      this.fillpage = new fullpage("#fullpage", {
        // sectionsColor: ['#f0f0f0', '#4BBFC3', '#7BAABE', 'whitesmoke', '#000'],
        // navigationTooltips: ['Section 1', 'Section 2', 'Section 3', 'Section 4', 'Section 5'],
        // anchors: ['section1', 'section2', 'section3', 'section4', 'section5'],
        // menu: '#menu',
        afterLoad: function (anchorLink, index) {
          // 滚动到新的页面后执行的回调函数
          _this.nowIndex = index.index;
        },
        onLeave: function (index, nextIndex, direction) {
          // 离开当前页面前执行的回调函数
        },
        normalScrollElements: "#map",
        // 其他fullpage配置项...
      });
    },
    initSwiper() {
      new Swiper(".swiper", {
        loop: true,
        autoplay: {
          delay: 3000,
        },
      });
    },
    backPage() {
      const scrollBox = document.getElementById("scrollBox");
      const scrollDistance = scrollBox.clientWidth;
      scrollBox.scrollBy({ left: -scrollDistance, behavior: "smooth" });
      this.page -= 1;
    },
    // 翻页
    goPage() {
      const scrollBox = document.getElementById("scrollBox");
      const scrollDistance = scrollBox.clientWidth;
      scrollBox.scrollBy({ left: scrollDistance, behavior: "smooth" });
      this.page += 1;
    },
    initMap() {
      this.map = new AMap.Map("map", {
        center: this.center,
        zoom: this.zoom,
      });

      const marker = new AMap.Marker({
        position: this.center,
        map: this.map,
      });
    },
    // 插件路由
    navigateToSection(sectionIndex) {
      this.fillpage.moveTo(sectionIndex);
    },
    // 获取公司招聘信息
    async getJobs() {
      const [err, res] = await this.$http.get("jobs");
      if (err) {
        return;
      }
      this.jobsList = res.list;
    },
    // 获取公司福利
    async getWelfare() {
      const [err, res] = await this.$http.get("welfare");
      if (err) {
        return;
      }
      res.list.forEach((item, index) => {
        item.img = this.imgList[index].img;
        item.imgclass = this.imgList[index].imgclass;
      });
      this.welfareList = res.list;
    },
    // 获取公司基础信息
    async getInfo() {
      const [err, res] = await this.$http.get("info");
      if (err) {
        return;
      }
      this.info = res;
    },
    //跳转招聘页面
    goWebPage(url) {
      window.open(url, "_blank");
    },
    changeIndex() {
      this.fillpage.moveSectionDown();
    },
  },
};
</script>
<style scoped lang="less">
@import "../../assets/css/base.less";
.png18 {
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
}
.section1 {
  position: relative;
  .page1 {
    position: relative;
    height: 100vh;
    margin: 0 auto;
    .content {
      position: relative;
      padding: 286px 240px 0 240px;
      display: flex;
      justify-content: space-between;
      .media1();
      .text_box {
        position: relative;
        height: 557px;
        width: 279px;
        .page {
          position: absolute;
          width: 279px;
          bottom: 0;
          left: 0;
          display: flex;
          justify-content: space-between;
          text-align: center;
          img {
            width: 70px;
            height: 70px;
          }
          .img_btn {
            width: 70px;
            height: 70px;
          }
          .btns {
            font-size: 14px;
            color: #000000;
            .page_btn {
              color: #e28a2b;
              font-size: 20px;
              font-weight: 600;
              line-height: 70px;
            }
          }
        }
      }
      .about_nineton_img {
        position: absolute;
        width: 279px;
        height: 557px;
        left: 0;
        top: 0;
        z-index: -1;
      }
      .img_box {
        display: flex;
        justify-content: space-between;
        width: 1135px;
        text-align: center;
        img {
          height: 264px;
          width: 248px;
        }
        .title {
          font-size: 32px;
          font-weight: 500;
          color: #000000;
          line-height: 45px;
          margin: 34px 0 18px 0;
        }
        .btn {
          width: 188px;
          height: 45px;
          border-radius: 23px;
          border: 1px solid #979797;
          margin: 0 auto;
          font-size: 18px;
          font-weight: 400;
          color: #000000;
          line-height: 45px;
          &:hover {
            background: #f7931e;
            border: 1px solid #f7931e;
            box-shadow: 0px 15px 34px 0px rgba(247, 147, 30, 0.45);
            border-radius: 37px;
            color: #fff;
            cursor: pointer;
            /* & {
              .QR_code {
                position: absolute;
                top: 50px;
                right: 0;
                transform: scale(1);
                transition: all 0.15s;
                img {
                  width: 160px;
                  height: 160px;
                  border-radius: 18px;
                  box-shadow: 0px 9px 63px 0px #e8e8e8;
                }
              }
            } */
          }
        }
      }
    }
  }
}
.section2 {
  .page2 {
    position: relative;
    height: 100vh;
    margin: 0 auto;
    overflow: hidden;
    .content {
      position: relative;
      padding: 164px 148px 0 240px;
      display: flex;
      .media1();
      // justify-content: space-between;
      // overflow: hidden;
      .text_box {
        position: relative;
        width: 279px;
        .page {
          position: absolute;
          width: 279px;
          bottom: 0;
          left: 0;
          display: flex;
          justify-content: space-between;
          text-align: center;
          img {
            width: 70px;
            height: 70px;
          }
          .img_btn {
            width: 70px;
            height: 70px;
          }
          .btns {
            font-size: 14px;
            color: #000000;
            .page_btn {
              color: #e28a2b;
              font-size: 20px;
              font-weight: 600;
              line-height: 70px;
            }
          }
        }
      }
      .welfare_list {
        position: absolute;
        right: 0;
        top: 172px;
        display: flex;
        flex-wrap: wrap;
        width: 1600px;
        overflow: hidden;
        .grid-item {
          width: 392px;
          height: 397px;
          padding: 54px 54px 0 34px;
          box-sizing: border-box;
          .num {
            .img01 {
              width: 77px;
              height: 70px;
            }
            .img02 {
              width: 98px;
              height: 71px;
            }
            .img03 {
              width: 100px;
              height: 71px;
            }
            .img04 {
              width: 106px;
              height: 71px;
            }
            .img05 {
              width: 101px;
              height: 71px;
            }
            .img06 {
              width: 103px;
              height: 71px;
            }
            .img07 {
              width: 101px;
              height: 71px;
            }
          }
          .title {
            font-size: 32px;
            font-weight: 600;
            color: #000000;
            line-height: 45px;
            margin: 16px 0 18px 0;
            font-family: "PingFang_Medium";
          }
          .cont {
            font-size: 22px;
            font-weight: 400;
            color: rgba(0, 0, 0, 0.6)
          }
        }
        .bgfff {
          background: #fff;
        }
        .bgd8d {
          background: rgba(216, 216, 216, 0.1);
        }
        .hidden {
          display: none;
        }
        /*   .item01 {
          opacity: 0.3;
        } */
        /* .item02 {
          opacity: 0.6;
        } */
      }
    }
  }
}

.section3 {
  position: relative;
  // justify-content: space-between;
  .page3 {
    position: relative;
    height: 100vh;
    margin: 0 auto;
    overflow: hidden;
    .content {
      position: relative;
      padding: 164px 148px 193px 240px;
      display: flex;
      .media1();
      .text_box {
        position: relative;
        height: 130px;
        width: 279px;
        .page {
          position: absolute;
          width: 279px;
          bottom: 0;
          left: 0;
          display: flex;
          justify-content: space-between;
          text-align: center;
          img {
            width: 70px;
            height: 70px;
          }
          .img_btn {
            width: 70px;
            height: 70px;
          }
          .btns {
            font-size: 14px;
            color: #000000;
            .page_btn {
              color: #e28a2b;
              font-size: 20px;
              font-weight: 600;
              line-height: 70px;
            }
          }
        }
      }
      .about_nineton_img {
        position: absolute;
        width: 279px;
        height: 557px;
        left: 0;
        top: 0;
        z-index: -1;
      }
      .img_box {
        height: 130px;
        padding-left: 161px;
        p {
          height: 25px;
          font-size: 18px;
          font-weight: 400;
          color: #000000;
          line-height: 25px;
        }
        .center {
          margin: 25px 0;
        }
      }
    }
    #map {
      height: 558px;
    }
  }
}
.xiahua {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 9999999;
  img {
    cursor: pointer;
  }
}
</style>
